"use client";
// Único enlace de acceso del sitio: «Entrar» sin sesión, «Mi espacio» con sesión. /entrar lleva a cada quien a su sitio.
import { useEffect, useState } from "react";

export function EnlaceEntrar({ idioma }: { idioma: "es" | "en" }) {
  const [dentro, setDentro] = useState(false);
  useEffect(() => { setDentro(document.cookie.split("; ").includes("sierra_marca=1")); }, []);
  const es = idioma === "es";
  return <a className="nav-entrar" href={dentro ? "/entrar" : `/${idioma}/entrar`}>{dentro ? (es ? "Mi espacio" : "My space") : (es ? "Entrar" : "Sign in")}</a>;
}
